import React from 'react';
import { convertToThousands, percentageValue, splitByThousands } from '../../helpers/NumberFormatter';

export default function AbsoluteValue(props) {
    const { value, convert } = props;
    if (isNaN(value)) {
        return <span>-</span>;  // or some other error handling
    }
    return <span title={splitByThousands(value)} className={props.className}>
        {convertToThousands(value)}  
    </span>    
}
